import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FooterComponent, HeaderComponent, MenuComponent, SubMenuComponent,SidebarComponent } from './components';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { MenubarModule } from 'primeng/menubar';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { MenuModule } from 'primeng/menu';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TreeModule } from 'primeng/tree';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TabViewModule } from 'primeng/tabview';
import { NgxCurrencyModule } from 'ngx-currency';
import { FieldsetModule } from 'primeng/fieldset';
import { RatingModule } from 'primeng/rating';
import { CalendarModule } from 'primeng/calendar';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ChipsModule } from 'primeng/chips';
import { PaginatorModule } from 'primeng/paginator';
import { SidebarModule } from 'primeng/sidebar';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { EditorModule } from 'primeng/editor';
import { ToastModule } from 'primeng/toast';
import { SelectButtonModule } from 'primeng/selectbutton';
import { AccordionModule } from 'primeng/accordion';
import { NgSelectModule } from '@ng-select/ng-select';

const BASE_MODULES = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule
];

const COMPONENTS = [
    HeaderComponent,
    FooterComponent,
    MenuComponent,
    SubMenuComponent,
    SidebarComponent
];
const PRIME_NG_MODULES = [
    ScrollPanelModule,
    MenubarModule,
    FieldsetModule,
    InputTextModule,
    ToastModule,
    MessagesModule,
    MessageModule,
    ButtonModule,
    ChipsModule,
    TableModule,
    InputSwitchModule,
    ToggleButtonModule,
    TreeModule,
    TabViewModule,
    DialogModule,
    ConfirmDialogModule,
    OverlayPanelModule,
    MultiSelectModule,
    TooltipModule,
    DropdownModule,
    RatingModule,
    SelectButtonModule,
    SidebarModule,
    InputTextareaModule,
    CheckboxModule,
    CalendarModule,
    MenuModule,
    EditorModule,
    PaginatorModule,
    AccordionModule
];
const OTHER_MODULES = [
    NgxJsonViewerModule,
    NgxCurrencyModule
];

@NgModule({
    imports: [...BASE_MODULES, ...PRIME_NG_MODULES, ...OTHER_MODULES, NgSelectModule],
    exports: [...BASE_MODULES, ...COMPONENTS, ...PRIME_NG_MODULES, ...OTHER_MODULES, NgSelectModule],
    declarations: [...COMPONENTS],
    providers: []
})
export class LayoutModule {
    static forRoot(): ModuleWithProviders<LayoutModule> {
        return {
            ngModule: LayoutModule,
            providers: [MessageService, ConfirmationService]
        };
    }
}
